import { lazy, Suspense } from "react";

const Login = lazy(() => import("./Login"));

function LoginPage() {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Login />
        </Suspense>
    )
}

export default LoginPage;